<script setup lang="ts">
    import { ref, computed, toRef } from 'vue'

    import type { CriteriaSurveyEmailSenderViewModel } from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyEmailSender'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: CriteriaSurveyEmailSenderViewModel
    }>()

    const emit = defineEmits<{
        (e: 'send-email', subject: string, body: string): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- local state ----------------

    const EmailSubject = ref<string>('Please complete this survey')
    const EmailBody = ref<string>('Please click on the following link to complete your survey: {url}')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const numberOfRecipients = computed(() =>
        vm.value.projectUserIds.length
    )

    const emailBodyError = computed<string | null>(() =>
        EmailBody.value.indexOf('{url}') === -1
            ? '{url} is required in the message.'
            : null
    )

    const emailSubjectError = computed<string | null>(() =>
        EmailSubject.value ? null : 'Email subject is required'
    )

    const hasErrors = computed(() =>
        emailSubjectError.value != null || emailBodyError.value != null
    )

    // ---------------- actions ----------------

    function handleSendEmail()
    {
        emit('send-email', EmailSubject.value, EmailBody.value)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>

    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Send email ({{numberOfRecipients}})</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Subject:</label>
                                <input type="text" class="form-control" v-model.trim="EmailSubject">
                                <div class="error">{{emailSubjectError}}</div>
                            </div>
                            <div class="form-group">
                                <textarea rows="5" class="form-control" v-model.trim="EmailBody"></textarea>
                                <div class="error">{{emailBodyError}}</div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                        <button @click="handleSendEmail" :disabled="hasErrors" type="button" class="btn btn-primary">Send email</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>